import React from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'
import { useAuthStore } from './stores/authStore'
import LoginPage from './pages/LoginPage'
import EmergencyLoginPage from './pages/EmergencyLoginPage'
import EditorPage from './pages/EditorPage'
import StatusPage from './pages/StatusPage'
import Layout from './components/Layout'
import StoreRouteGuard from './components/StoreRouteGuard'

function App() {
  const { isAuthenticated, user, requiresStoreSelection } = useAuthStore()

  return (
    <div className="min-h-screen bg-gray-50">
      <Routes>
        <Route 
          path="/login" 
          element={isAuthenticated && !requiresStoreSelection ? <Navigate to="/" /> : <LoginPage />} 
        />
        <Route 
          path="/logindev" 
          element={isAuthenticated && !requiresStoreSelection ? <Navigate to="/" /> : <LoginPage />} 
        />
        <Route 
          path="/emergency" 
          element={isAuthenticated && !requiresStoreSelection ? <Navigate to="/" /> : <EmergencyLoginPage />} 
        />
        <Route 
          path="/editor/:siteId/*" 
          element={
            isAuthenticated && !requiresStoreSelection ? (
              <Layout>
                <StoreRouteGuard>
                  <EditorPage />
                </StoreRouteGuard>
              </Layout>
            ) : (
              <Navigate to="/login" />
            )
          } 
        />
        <Route 
          path="/status" 
          element={
            isAuthenticated && user?.isMultiStore ? (
              <Layout>
                <StatusPage />
              </Layout>
            ) : (
              <Navigate to="/" />
            )
          } 
        />
        <Route 
          path="/" 
          element={
            isAuthenticated && user && !requiresStoreSelection ? (
              <Navigate to={`/editor/${user.storeName}/home`} />
            ) : (
              <Navigate to="/login" />
            )
          } 
        />
      </Routes>
    </div>
  )
}

export default App
